import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import css from './IconTransfers.module.css';

const IconTransfers = props => {
  const { className, rootClassName } = props;
  const classes = clsx(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 20.0128L8.7625 19.999"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.25 20.0128L21.2625 19.999"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 15H26.25V23.75C26.25 24.0815 26.1183 24.3995 25.8839 24.6339C25.6495 24.8683 25.3315 25 25 25H5C4.66848 25 4.35054 24.8683 4.11612 24.6339C3.8817 24.3995 3.75 24.0815 3.75 23.75V15Z"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 10V7.5C26.25 6.17392 25.7232 4.90215 24.7855 3.96447C23.8479 3.02678 22.5761 2.5 21.25 2.5H8.75C7.42392 2.5 6.15215 3.02678 5.21447 3.96447C4.27678 4.90215 3.75 6.17392 3.75 7.5V10"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 10H21.25"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 25H10V27.5C10 27.8315 9.8683 28.1495 9.63388 28.3839C9.39946 28.6183 9.08152 28.75 8.75 28.75H6.25C5.91848 28.75 5.60054 28.6183 5.36612 28.3839C5.1317 28.1495 5 27.8315 5 27.5V25Z"
        fill="#6E7191"
      />
      <path
        d="M20 25H25V27.5C25 27.8315 24.8683 28.1495 24.6339 28.3839C24.3995 28.6183 24.0815 28.75 23.75 28.75H21.25C20.9185 28.75 20.6005 28.6183 20.3661 28.3839C20.1317 28.1495 20 27.8315 20 27.5V25Z"
        fill="#6E7191"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconTransfers.defaultProps = {
  className: null,
  rootClassName: null,
};

IconTransfers.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconTransfers;
